"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _errorMessagingJs = require("error-messaging-js");

var _constants = require("settings-ui-sdk/Blogs/constants");

var _actions = require("settings-ui-sdk/Blogs/actions");

var _BlogErrorTokens = require("../constants/BlogErrorTokens");

var _UpdateBlogSettings = _interopRequireDefault(require("../stagedObjects/UpdateBlogSettings"));

var _Map, _handleActions;

var ERROR_PREFIX_KEY = 'marketing.blog.errors';
var defaultValidationState = (0, _immutable.Map)({
  isValid: true,
  errorMessage: null
});
var initialState = (0, _immutable.Map)((_Map = {}, (0, _defineProperty2.default)(_Map, _constants.NAME, defaultValidationState), (0, _defineProperty2.default)(_Map, _constants.SLUG, defaultValidationState), (0, _defineProperty2.default)(_Map, _constants.DOMAIN, defaultValidationState), _Map));

var getErrorToken = function getErrorToken(error) {
  if (error.responseJSON) {
    return error.responseJSON.errorType;
  }

  return null;
};

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.UpdateBlogActionTypes.FAILURE, function (state, _ref) {
  var error = _ref.payload.error;
  var errorToken = getErrorToken(error);
  var errorMessage = (0, _errorMessagingJs.getTranslatedErrorMessage)({
    response: error,
    prefixKey: ERROR_PREFIX_KEY + ".update"
  });

  switch (errorToken) {
    case _BlogErrorTokens.BLOG_NAME_MISSING:
    case _BlogErrorTokens.BLOG_NAME_EXISTS:
    case _BlogErrorTokens.BLOG_NAME_TOO_LONG:
    case _BlogErrorTokens.BLOG_NAME_NO_HTML:
      return state.set(_constants.NAME, (0, _immutable.Map)({
        isValid: false,
        errorMessage: errorMessage
      }));

    case _BlogErrorTokens.BLOG_SLUG_TOO_LONG:
      return state.set(_constants.SLUG, (0, _immutable.Map)({
        isValid: false,
        errorMessage: errorMessage
      }));

    case _BlogErrorTokens.PAGE_EXISTS:
    case _BlogErrorTokens.BLOG_URL_EXISTS:
    case _BlogErrorTokens.BLOG_DOMAINS_ENTERPRISE_ONLY:
    case _BlogErrorTokens.CONTENT_GROUP_URL_CHANGE_CONFLICT:
    case _BlogErrorTokens.FAILED_TO_UPDATE_SLUGS_WITH_NEW_ROOT_DATA_TRUNCATED:
      return state.set(_constants.DOMAIN, (0, _immutable.Map)({
        isValid: false,
        errorMessage: errorMessage
      }));

    default:
      return state;
  }
}), (0, _defineProperty2.default)(_handleActions, _UpdateBlogSettings.default.getChangePropertyActionType(_constants.NAME), function (state) {
  return state.set(_constants.NAME, defaultValidationState);
}), (0, _defineProperty2.default)(_handleActions, _UpdateBlogSettings.default.getChangePropertyActionType(_constants.SLUG), function (state) {
  return state.set(_constants.SLUG, defaultValidationState);
}), (0, _defineProperty2.default)(_handleActions, _UpdateBlogSettings.default.getChangePropertyActionType(_constants.DOMAIN), function (state) {
  return state.set(_constants.DOMAIN, defaultValidationState);
}), (0, _defineProperty2.default)(_handleActions, _UpdateBlogSettings.default.getStageForEditActionType(), function () {
  return initialState;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;